// 导入请求数据的 request 模块
import request from '@/utils/request'

// 插入留言
export const insertMessage = (message) => {
  return request.post('/message/insert', message)
}
